import { GET_PORT_TERMINALS, GET_VOYAGE_PORT_TERMINALS } from './../constants/actionTypes'
import get from 'lodash/get'

const initStore = {
  portterminals: [],
  pages: {}
}

const port = (store = initStore, action = {}) => {
  switch (action.type) {
    case GET_PORT_TERMINALS: {
      const page = get(action, 'data.data.page', {})
      const portterminals =
        page.page === 1
          ? get(action, 'data.data.portterminals', [])
          : [
              ...get(store, 'portterminals', []),
              ...get(action, 'data.data.portterminals', [])
            ]
      return {
        page,
        portterminals
      }
    }
    case GET_VOYAGE_PORT_TERMINALS: {
      const page = get(action, 'data.data.page', {})
      const voyageEmbarkPortTerminalResponses =
        page.page === 1
          ? get(action, 'data.data.voyageEmbarkPortTerminalResponses', [])
          : [
              ...get(store, 'voyageEmbarkPortTerminalResponses', []),
              ...get(action, 'data.data.voyageEmbarkPortTerminalResponses', [])
            ]
      return {
        page,
        voyageEmbarkPortTerminalResponses
      }
    }
    default:
      return store
  }
}

export default port
